// extracted by mini-css-extract-plugin
export default {"container":"WaitingList_container__vIT6H","page":"WaitingList_page__Hys+N"};